export const employeesApiErrorsTranslations = {
  INVALID_EMAIL: 'employees:employees.uploadDialog.invalidEmail',
  EMPTY_FILE: 'employees:employees.uploadDialog.emptyFile',
} as const;
